/**
 * @desc 获取分期金额接口
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** bankId */
  bankId?: string
  /** @Min: 1.0 - @Max: null (until #1244 gets fixed) */
  detail: number
  /** orderNo */
  orderNo: string
  /** paymentChannelType */
  paymentChannelType?: number
  /** @Min: 1.0 - @Max: null (until #1244 gets fixed) */
  paymentPlatformType: number
  /** sign */
  sign: string
  /** token */
  token: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/installmentAmount',
    params,
    method: 'get',
  })
}
